<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a>{{company_full_name}}:</a></li>
    <li class="active"><a>Profile</a></li>
    <li class="active"><a>Edit Profile</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="newform_outer">
          <div class="filter_div">
            <div class="top">
              <h4>Edit Profile</h4>
            </div>
          </div>
          <div class="both_side edit_profile">
            <div class="left_side">
              <h4>Company Logo</h4>
              <div class="inner">
                <div class="upload">
                  <img src="{{_companyLogo}}" class="companyLogo" alt="User" onerror="this.src='./assets/img-new/default_user.png'">
                  <div class="action_btn">
                    <div class="upload-btn-wrapper">
                      <button class="btn default_btn" mat-raised-button (click)="inputFile.click()">Replace</button>
                      <input #inputFile type="file" name="myfile" ng2FileSelect [uploader]="companyUploader"
                        (change)="upload($event.target.files, 'companyLogo')"/>
                    </div>
                    <button class="btn default_btn" mat-raised-button 
                      (click)="removeUserImage('companyLogo')">Remove</button>
                  </div>
                  <div class="support">
                    <h5>Supported formats:<span>jpg, png, gif</span></h5>
                    <h5>Maximum Size:<span>500KB</span></h5>
                  </div>
                </div>
                <h4>Client Picture</h4>
                <div class="upload">
                  <img src="{{_imgUrl}}" alt="User">
                  <div class="action_btn">
                    <div class="upload-btn-wrapper">
                      <button class="btn default_btn" mat-raised-button (click)="inputFile.click()">Replace</button>
                      <input #inputFile type="file" name="myfile" ng2FileSelect [uploader]="uploader" (change)="upload($event.target.files, 'clientPicture')"/>
                    </div>
                    <button class="btn default_btn" mat-raised-button (click)="removeUserImage('clientPicture')">Remove</button>
                  </div>
                  <div class="support">
                    <h5>Supported formats:<span>jpg, png, gif</span></h5>
                    <h5>Maximum Size:<span>500KB</span></h5>
                  </div>
                </div>
              </div>
            </div>


            <form [formGroup]="uForm" (ngSubmit)="updateUserInfo()">
              <div class="right_side">
                <h4>User Details</h4>
                <div class="row" *ngIf="userRoll != 'USER'">
                  <div class="col col-md-6">
                    <label>Company Name *</label>
                    <input type="text" class="form-control" formControlName="company_name" id="company_name">
                    <control-messages class="err-msg" [control]="uForm.controls.company_name"></control-messages>
                  </div>
                  <div class="col col-md-6">
                    <label>Industry Type *</label>
                    <span class="custom_select_outer">
                      <select class="custom_select form-control" formControlName="industry_type" id="industry_type">
                        <option *ngFor="let industry of industryType">{{industry.title}}</option>
                      </select>
                    </span>
                    <control-messages class="err-msg" [control]="uForm.controls.industry_type"></control-messages>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <label>Client Name *</label>
                    <input type="text" class="form-control" formControlName="full_name" id="full_name">
                    <!-- <control-messages class="err-msg" [control]="uForm.controls['full_name']"></control-messages> -->
                  </div>
                  <div class="col col-md-6">
                    <label>Email Address *</label>
                    <input type="text" class="form-control" formControlName="email" id="email">
                    <!-- <control-messages class="err-msg" [control]="uForm.controls['email']"></control-messages> -->
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col col-md-6">
                    <label>Phone Number *</label><br>
                    <input type="text"

                    class="form-control"
                    formControlName="phone_number" id="phone_number"
                    (countryChange)="onCountryChange($event)" />
                  </div> -->
                  <div class="col col-md-6">
                            <label>Phone Number *</label>
                            <ngx-intl-tel-input
                            [cssClass]="'form-control phone-input'"
                             [preferredCountries]="['in', 'us','ca']"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="['name', 'dialCode', 'iso2']"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="''"
                            formControlName="phone_number" id="phone_number"
                            (ngModelChange)="onCountryChange($event)"
                            [phoneValidation]="true"
                          ></ngx-intl-tel-input>
                  </div>
                </div>
                <!-- <control-messages class="err-msg" [control]="uForm.controls['phone_number']"></control-messages> -->
                <hr class="horizontal_line">

                <div class="row">
                  <div class="col col-md-6">
                    <label>Address Line 1 *</label>
                    <input type="text" class="form-control" formControlName="address_line1" id="address_line1">
                    <!-- <control-messages class="err-msg" [control]="uForm.controls['address_line1']"></control-messages> -->
                  </div>
                  <div class="col col-md-6">
                    <label>Address Line 2</label>
                    <input type="text" class="form-control" formControlName="address_line2" id="address_line2">
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <div class="row">
                      <div class="col col-md-6">
                        <label>Country *</label>
                        <span class="custom_select_outer">
                          <select class="custom_select form-control" formControlName="country_name_"
                            (ngModelChange)="onChange($event)">
                            <option *ngFor="let countrys of countryNames" [value]="countrys.country">
                              {{countrys.country}}</option>
                          </select>
                          <!-- <control-messages class="err-msg" [control]="uForm.controls['country_name_']"></control-messages> -->
                        </span>
                      </div>

                      <div class="col col-md-6">
                        <label>State/Province*</label>
                        <span class="custom_select_outer">
                          <select class="custom_select form-control" formControlName="state_name">
                            <option></option>
                            <option *ngFor="let state of states"  [value]="state">
                              {{state}}</option>
                          </select>
                          <!-- <control-messages class="err-msg" [control]="uForm.controls['state_name']"></control-messages> -->
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col col-md-6">
                    <div class="row">
                      <div class="col col-md-6">
                        <label>City *</label>
                        <input type="text" class="form-control" formControlName="city_name" id="city_name">
                        <!-- <control-messages class="err-msg" [control]="uForm.controls['city_name']"></control-messages> -->
                      </div>
                      <div class="col col-md-6">
                        <label>Postal Code *</label>
                        <input type="text" class="form-control" formControlName="postcode" id="postcode">
                        <!-- <control-messages class="err-msg" [control]="uForm.controls['postcode']"></control-messages> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <div class="row">
                      <div class="col col-md-6">
                        <label>TimeZone *</label>
                        <span class="custom_select_outer">
                          <select class="custom_select form-control" formControlName="timezone">
                            <option *ngFor="let timezone of timeZones" [value]="timezone"> {{timezone}}</option>
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!--product type-->
                <div *ngIf="userRoll === 'CLIENT'">

                    <hr class="horizontal_line">
                    <h4>Product Type</h4>
                    <div class="product-checkbox" formArrayName="ProductCheckBox">
                      <ul class="checkbox-container">
                      <li *ngFor="let item of productBoxList; let i = index" class="checkbox-item">
                        <input type="checkbox" style="width: 24px; margin: -4px 30px;" [formControlName]="i" [value]="item.id" [checked]="item.checked" disabled>
                      <label style="width: 180px; margin-left:-20px">{{item.name}}</label>

                      </li>
                     </ul>
                    </div>

                  <!-- <hr class="horizontal_line">
                  <h4>Product Type</h4>
                  <div class="OEM-checkbox" formArrayName="ProductCheckBox">
                    <li *ngFor="let item of productBoxList; let i = index">
                      <input type="checkbox" style="width: 24px; margin: -4px 30px;" [formControlName]="i" [value]="item.id" [checked]="item.checked" disabled>
                      <label style="width: 180px; margin-left:-20px">{{item.name}}</label>
                    </li>
                  </div> -->
                </div>
                <!--product type-->
                <hr class="horizontal_line" *ngIf="userRoll != 'USER'">
                <label *ngIf="userRoll != 'USER'">License Type</label>
                <div class="row" *ngIf="userRoll != 'USER'">
                  <div class="col col-md-4" *ngFor="let lic of licenceTypeArray; let inx = index;">
                    <div class="checkflex_field">
                      <div class="check_right">
                        <label>{{lic.device_type}}</label>
                        <input type="text" id="license_number_{{inx}}" disabled="disabled"
                          [value]="lic.number_of_licence" class="form-control" placeholder="Enter number of licenses">
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="horizontal_line" *ngIf="userRoll != 'USER'">
                <div class="row" *ngIf="userRoll != 'USER'">
                  <div class="col col-md-6">
                    <label>Account Manager</label>
                    <input type="text" class="form-control" disabled="disabled" formControlName="account_manager"
                      id="account_manager">
                  </div>
                </div>
                <hr class="horizontal_line">
                <div class="form_actions text-right">
                  <button *ngIf="!updateDataReq" mat-raised-button color="primary"
                    [disabled]="!uForm.valid"><span>Create</span></button>
                  <button type="submit" *ngIf="updateDataReq" mat-raised-button color="primary"
                  [disabled]="!(uForm.valid && uForm.dirty)" ><span>Update</span></button>
                  <button mat-stroked-button color="warn" (click)="gotoHome()"><span>Cancel</span></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>